import React from 'react';

import cn from 'classnames';
import { useTranslation } from 'react-i18next';

import { AdminConversationUserHistory } from '@entities/adminConversationUserHistory';
import { AdminConversationUsersSearchForm } from '@features/AdminConversationUsersSearchForm';
import { UiButton } from '@shared/ui';

import cls from './AdminConversationSendForm.module.css';
import { useAdminConversationSendForm } from '../lib/hooks/useAdminConversationSendForm';

interface AdminConversationSendFormProps {
    classes?: string;
}

export const AdminConversationSendForm = ({ classes }: AdminConversationSendFormProps) => {
    useAdminConversationSendForm();

    const { t } = useTranslation();

    return (
        <div className={cn(cls.AdminConversationSendForm, [classes])}>
            <h1>Отправка пользователям</h1>
            <UiButton
                onClick={() => {
                    window.location.href = '/admin/conversation/view';
                }}
                className={cls.buttonBack}
                btnText={t('button.back.text')}
            />
            <AdminConversationUsersSearchForm />
            <AdminConversationUserHistory />
        </div>
    );
};
